
import moment from "moment";
import React, { useState, useMemo, useEffect } from "react";
import Zergling from "../../../../helpers/zergling";
import { getPredefinedMultiples } from "../../../../helpers/terminalRequests/predefinedMultiples";
import { GetArrayForAllLayers } from "../../../../helpers/util/swarmTreeDestructuring";
import OddConverter from "@common/helpers/oddConverter";
import MultiplesItemPlaceBet from "./multiplesItemPlaceBet";
import { t } from '../../../../helpers/translator';
import Expandable from "../../../containers/expandable";
import Config from "../../../../config/main";

const MultiplesItem = ({ multiple, oddsFormat, bonusPercent }) => {
    const [events, setEvents] = useState(null);
    const totalOdd = useMemo(() => events?.reduce((acc, item) => acc *= item.price, 1) || 0, [events])

    useEffect(() => {
        (async () => {
            const selectionIds = multiple.Selections.map(item => item.SelectionId);
            const gameIds = multiple.Selections.map(item => item.MatchId);
            const { data } = await Zergling.get(getPredefinedMultiples(selectionIds, gameIds));
            const events = GetArrayForAllLayers(data);

            setEvents(events);
        })();
    }, []);

    return <div className="multiple-block">
        <div className="predefined-multiples-header">
            <div className="info-block">
                <div>
                    <h2>{multiple.Name}</h2>
                    <h3>{t("Expires At:")} {moment(multiple.ExpiresAt).format(Config.main.dateFormat)}</h3>
                </div>
                <div>
                    <h2 className="multiple-count">{t("Total Bonus:")}<span> {bonusPercent}%</span></h2>
                </div>
            </div>
            <>
               {/*{multiple.Selections.length >= 4 && <Expandable className={"single-market-title-m"} uiKey={multiple.Id} initiallyExpanded={multiple.Selections.length >= 4}>*/}
                    {/*<div className="markets-closed-open-arrow-m" />*/}
                {/*</ Expandable >}*/}
                <div className="predefined-multiples-check-items">
                    {events?.map(event => <div key={event.id} className="multiples-event-item">
                        <div className="left-block">
                            <span className="team-name">{event.game.team1_name} - {event.game.team2_name}</span>
                            <span>{event.market.name}</span>
                            <span className="event-name">{event.name} {event.base}</span>
                        </div>
                        <div className="right-block">
                            <span>{moment.unix(event.game.start_ts).format(Config.main.timeFormat)}</span>
                            <span>{OddConverter(event.price, oddsFormat)}</span>
                        </div>
                    </div>)}
                </div>
            </>
        </div>
        <MultiplesItemPlaceBet
            totalOdd={totalOdd}
            bonusPercent={bonusPercent}
            multiple={multiple}
            events={events}
        />
    </div>
};

export default MultiplesItem;


// const copyToBetSlip = async () => { //TODO Refactoring
//     events.forEach(({
//         game, sport, region, competition, market, ...event
//     }) => dispatch(addEventCompareConflicts({
//         ...game,
//         alias: sport.alias,
//         regionId: region.id,
//         competitionId: competition.id
//     }, market, event, event.id)));
// }


{/* <button className="button-view-normal-m" onClick={copyToBetSlip}>
{t("Add To Betslip")}
</button> */}